import { demoPayments } from '@/mocks/demoData';
import type { Payment } from '@/mocks/data';
import { reducePendingAmount } from '@/utils/bookingStore';
import { addActivityLog } from '@/utils/activityLogStore';

let payments: Payment[] = [...demoPayments];

export function getPayments(): Payment[] {
  return payments;
}

export function addPayment(payment: Payment): void {
  payments = [payment, ...payments];
  reducePendingAmount(payment.booking_id, payment.amount);
  addActivityLog({
    user_id: payment.created_by || 'usr-003',
    user_name: 'Reception',
    action: 'Payment Received',
    entity_type: 'payment',
    entity_id: payment.id,
    details: { amount: payment.amount, method: payment.payment_method, receipt: payment.receipt_no },
  });
}

export function getPaymentsByBooking(bookingId: string): Payment[] {
  return payments.filter((p) => p.booking_id === bookingId);
}

export function getTotalPaidForBooking(bookingId: string): number {
  return payments
    .filter((p) => p.booking_id === bookingId)
    .reduce((sum, p) => sum + p.amount, 0);
}

export function generateReceiptNo(): string {
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const todayPayments = payments.filter((p) => p.receipt_no.includes(today));
  const seq = String(todayPayments.length + 1).padStart(3, '0');
  return `RCP-${today}-${seq}`;
}

export function generatePaymentId(): string {
  return `pay-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
}